import { useState, useEffect } from "react";
import { Tooltip } from "@chakra-ui/react";
import Button from "../Button";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";
import HeaderBar from "../HeaderBar";
import { unauthenticatedApi } from "../../Api";

const PreSale = (props) => {
    const {actions, state} = useStateMachineWrapper();

    const [isLoading, setIsLoading] = useState(false);
    const [isValidResponse, setIsValidResponse] = useState(true);

    // use this to get the current promos, pricing, etc.
    useEffect(() => {
      setIsLoading(true);

      // TODO: get this on page load as well in case the offers are different
      unauthenticatedApi.get(`?endpoint=get-available-services&zip=${state.session.currentAddress.fill_zip}&market-id=${state.session.currentAddress.market_id}&sector=${state.session.currentAddress.sector}`)
            .then(response => {
                if(response.status != 200) {
                    setIsValidResponse(false);
                }
                actions.update({availableServices: response.data});
                setIsLoading(false);
            });
    }, []);


return (<>
        {/* <h1>Great News!<br/>We are bringing i3 {session.isRiMarket() ? 'Internet' : 'Fiber'} to your neighborhood soon.</h1> */}

        {/* <h1>We're on our way!</h1> */}
        {/* <p>Our construction crews are gearing up and i3 Fiber is coming to your neighborhood soon.</p> */}

        <HeaderBar backPage={'intro'} nextPage={null}>
          <h1>We're on our way!</h1>
          <p>Our construction crews are gearing up and i3 Fiber is coming to your neighborhood soon.</p>
        </HeaderBar>

        <div className="flex flex-col md:flex-row justify-center gap-4 mt-4">
        {isValidResponse === true && (<>
            <Tooltip label="Click here to pre-order services and lock in your offer.">
                <Button size="large" color="purple" enabled={isValidResponse} loading={isLoading} onClick={() => actions.update({isPreorder: true, page: 'choose-internet'})}>Reserve My Services</Button>
            </Tooltip>

            {<Tooltip label="Click here to receive updates when our fiber is ready.">
                <Button size="large" enabled={isValidResponse} loading={isLoading} onClick={() => actions.setPage('presale-notify')}>Keep Me Updated</Button>
            </Tooltip>}
        </>)}
        {isValidResponse !== true && (<>
            <h1 className="big">Error - we were unable to find anything for your address. Please contact us if this error continues.</h1>
        </>)}
        </div>
    </>)
};

export default PreSale;